<template>
  <div>
    <h3>Chapters</h3>
    <br />
    <img class="borderedImage borderedImageRight" src="../assets/Chapters.jpg" />
    <br />
    <h5>Please join our<a href="https://www.eatsonfeetsforum.com" target="blank"> Forum</a> if you do not have a Facebook account or if your Facebook Chapter does not have a Community Group.</h5>
    <br />
    <h5>Follow our <a href="https://www.facebook.com/EatsOnFeetsHome" target="_blank"> Home Page</a> on Facebook for milksharing information.</h5>
    <div class="chaptersView">
      <label for="selectRegion"><h5>Select a region to find your Chapters:</h5> </label>
      <br />
      <select v-model="selectedRegion" name="selectRegion">
        <option v-for="(region, idx) of regions" :key="idx" :value="region">
          {{ region.name }}
        </option>
      </select>
      <div class="chapterList">
        <div class="chapterContainer" v-if="regionSelected">
          <div v-for="country of selectedRegion.countries" :key="country.name">
            <CountryDetail :country="country" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { RegionsState, Region} from '../store/regions/types'

import CountryDetail from '../components/CountryDetail.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Chapters',
  components: { CountryDetail },
  data() {
    return {
      selectedRegion: { name: 'The Americas' },
      regionSelected: true
    }
  },
  metaInfo: {
    title: 'Eats On Feets - Chapters',
    titleTemplate: null
  },
  computed: mapState({
    regions: state => state.regions.regions
  }),

  methods: {
    ...mapActions('regions', [
      'loadRegions'
    ]),
    selectRegion(region) {
      this.selectedRegion = region
      this.regionSelected = true
    },
    countriesForSelectedRetion() {
      if (this.selectedRegion) {
        return this.selectedRegion.countries.sort((a, b) => (a.name > b.name) ? 1 : -1)
      }
      return []
    }
  },
  watch: {
    regions() {
      if (this.regions && this.regions[0]) {
        this.selectRegion(this.regions[0])
      }
    }
  },
  async mounted() {
    await this.loadRegions()
    process.nextTick(() => {
      if (this.regions && this.regions[0]) {
        this.selectRegion(this.regions[0])
      }
    })
  }

}
</script>

<style lang="scss" scoped>
.chaptersView {
  padding: 20px;
  label {
    margin-right: 10px;
  }
  select {
    margin-bottom: 20px;
  }

}
</style>
